import { createContext, useCallback, useMemo, type PropsWithChildren } from 'react';

type AnalyticsContextValue = {
  trackEvent: (eventName: string, payload?: Record<string, unknown>) => void;
};

export const AnalyticsContext = createContext<AnalyticsContextValue | null>(null);

export function AnalyticsProvider({ children }: PropsWithChildren) {
  const trackEvent = useCallback((eventName: string, payload: Record<string, unknown> = {}) => {
    window.dispatchEvent(new CustomEvent('divergente:analytics', { detail: { eventName, payload } }));
  }, []);

  const value = useMemo(() => ({ trackEvent }), [trackEvent]);

  return <AnalyticsContext.Provider value={value}>{children}</AnalyticsContext.Provider>;
}
